import { useState } from 'react'

import { useScreen } from '@hozana/screen/useScreen'

import { Panel } from 'elements/ui/Panel'

import { TPrayerMeeting } from 'modules/meeting/types'

import { TPrayerEvent } from '../../types'
import { PrayerMeetingInfo } from './PrayerMeetingInfo'
import { PrayerMeetingInvite } from './PrayerMeetingInvite'

type PrayerMeetingPanelProps = {
  prayerEvent: TPrayerEvent
  prayerMeeting: TPrayerMeeting
  onPanelClose: () => void
}

export const PrayerMeetingPanel: TFC<PrayerMeetingPanelProps> = ({ prayerEvent, prayerMeeting, onPanelClose }) => {
  const screen = useScreen()
  const [tab, setTab] = useState<'info' | 'invite'>('info')

  return (
    <Panel
      from={screen.xs ? 'bottom' : 'right'}
      open={!!prayerMeeting}
      size={{ xs: '80%', md: '50%', lg: '30%' }}
      back={tab == 'invite' ? () => setTab('info') : null}
      close={tab == 'invite' ? null : onPanelClose}
      m="5px"
    >
      {tab === 'info' ? (
        <PrayerMeetingInfo prayerEvent={prayerEvent} prayerMeeting={prayerMeeting} setTab={setTab} />
      ) : (
        <PrayerMeetingInvite prayerEvent={prayerEvent} prayerMeeting={prayerMeeting} />
      )}
    </Panel>
  )
}
